import { render, staticRenderFns } from "./IconUserCircle.vue?vue&type=template&id=c8577f1a"
import script from "./IconUserCircle.vue?vue&type=script&lang=js"
export * from "./IconUserCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports